import { StyleSheet } from 'react-native';

import { C } from '../../../../common';
import { THEME } from '../../../../reactor/common';

const { COLOR, UNIT, OFFSET } = THEME;

export default StyleSheet.create({
  container: {
    ...C.PAGE_CONTENT,
    alignContent: 'center',
    alignItems: 'center',
    height: '100%',
    justifyContent: 'center',
  },

  image: {
    backgroundColor: COLOR.TRANSPARENT,
    width: UNIT * 22.4,
    height: UNIT * 6,
  },

  title: {
    marginTop: '7.5%',
    marginBottom: '2.5%',
  },

  text: {
    textAlign: 'center',
  },

  button: {
    alignSelf: 'center',
    marginTop: OFFSET,
    width: UNIT * 25.6,
  },
});
